import {
  ADD_CAMPAIGN_DEVICE_TYPES,
  DELETE_CAMPAIGN_DEVICE_TYPES,
  GET_CAMPAIGN_DEVICE_TYPE_PROFILE,
  GET_CAMPAIGN_DEVICE_TYPES_LIST,
  HIDE_CAMPAIGN_DEVICE_TYPES_LOADER,
  SET_CAMPAIGN_DEVICE_TYPE_PROFILE,
  SET_CAMPAIGN_DEVICE_TYPES_LIST,
  SET_ERROR_CAMPAIGN_DEVICE_TYPE_PROFILE,
  SHOW_CAMPAIGN_DEVICE_TYPES_LOADER,
  UPDATE_CAMPAIGN_DEVICE_TYPE_PROFILE
} from "./actionTypes";

export const getCampaignDeviceTypesList = data => ({
  type: GET_CAMPAIGN_DEVICE_TYPES_LIST,
  payload: data
})

export const setCampaignDeviceTypesList = payload => ({
  type: SET_CAMPAIGN_DEVICE_TYPES_LIST,
  payload
})

export const showCampaignDeviceTypesListLoader = () => ({
  type: SHOW_CAMPAIGN_DEVICE_TYPES_LOADER
})

export const hideCampaignDeviceTypesListLoader = () => ({
  type: HIDE_CAMPAIGN_DEVICE_TYPES_LOADER
})

export const addCampaignDeviceType = (deviceType = {}, data = {}) => ({
  type: ADD_CAMPAIGN_DEVICE_TYPES,
  payload: { deviceType, data }
});

export const deleteCampaignDeviceType = (id, data = {}) => ({
  type: DELETE_CAMPAIGN_DEVICE_TYPES,
  payload: { id, data }
});

export const getCampaignDeviceTypeProfile = id => ({
  type: GET_CAMPAIGN_DEVICE_TYPE_PROFILE,
  payload: id
})

export const setCampaignDeviceTypeProfile = payload => ({
  type: SET_CAMPAIGN_DEVICE_TYPE_PROFILE,
  payload
})

export const updateCampaignDeviceTypeProfile = (id, deviceType = {}, data = {}) => ({
  type: UPDATE_CAMPAIGN_DEVICE_TYPE_PROFILE,
  payload: {id, deviceType, data }
})

export const setErrorCampaignDeviceTypeProfile = payload => ({
  type: SET_ERROR_CAMPAIGN_DEVICE_TYPE_PROFILE,
  payload
})